import { actionTypes } from '~/src/features/full-buy/store';
import { IPromoCode } from '~/src/features/full-buy/store/initialState';

export const setPromoCode = (data: IPromoCode | null) => ({
    type: actionTypes.SET_PROMO_CODE,
    payload: data,
});
